<template>
  <div>
    <v-alert
      v-if="open"
      text
      color="primary"
      class="ma-4 mb-2"
      dismissible
      @input="dismiss"
    >
      <div class="text-subtitle-1 font-weight-medium mb-1">
        <v-icon color="primary" small class="me-1">mdi-lightbulb-on-outline</v-icon>
        {{ $t(title) }}
      </div>
      <div class="text-body-2">{{ $t(body) }}</div>
      <ul v-if="points.length" class="text-body-2 mt-2">
        <li v-for="point in points" :key="point">{{ $t(point) }}</li>
      </ul>
      <div v-if="next" class="text-body-2 mt-2">
        <strong>{{ $t('help_next') }}</strong> {{ $t(next) }}
      </div>
    </v-alert>

    <!-- once dismissed the page keeps a way back to the explanation, so
         closing it is not a decision the admin cannot undo -->
    <div v-else class="text-right pe-4 pt-2">
      <v-btn x-small text color="primary" @click="reopen">
        <v-icon x-small class="me-1">mdi-help-circle-outline</v-icon>
        {{ $t('what_is_this_page') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
/*
 * What a page is for, said on the page itself.
 *
 * The panel assumes its own order - stops before routes, a route and a driver
 * before a trip - and said none of it out loud, so an admin meeting a screen
 * for the first time had to work backwards from whatever it refused to do.
 *
 * The admin can close it, and that choice is remembered per page, so it
 * explains itself once rather than every visit.
 */
const STORAGE_PREFIX = "page-help-dismissed:";

export default {
  name: "PageHelp",
  props: {
    //identifies the page in storage, so dismissing one does not dismiss the rest
    page: { type: String, required: true },
    title: { type: String, required: true },
    body: { type: String, required: true },
    //short list of what to do here
    points: { type: Array, default: () => [] },
    //the step that usually follows this one
    next: { type: String, default: "" },
  },
  data() {
    return {
      open: true,
    };
  },
  mounted() {
    this.open = !this.wasDismissed();
  },
  methods: {
    storageKey() {
      return STORAGE_PREFIX + this.page;
    },
    wasDismissed() {
      try {
        return localStorage.getItem(this.storageKey()) === "1";
      } catch (e) {
        //private browsing can refuse storage, and help that cannot be
        //remembered is better than a page that fails to render
        return false;
      }
    },
    dismiss() {
      this.open = false;
      try {
        localStorage.setItem(this.storageKey(), "1");
      } catch (e) {
        //nothing to do: it will simply be shown again next time
      }
    },
    reopen() {
      this.open = true;
      try {
        localStorage.removeItem(this.storageKey());
      } catch (e) {
        //same again
      }
    },
  },
};
</script>
